import React from "react";
import "../Contact/contact.scss";
import MapBlur from "../../Assets/Images/map-blur.png";
import { AnimatedOnScroll } from "react-animated-css-onscroll";


const Contact = () => {
  return (
    <>
      {/* <Header/> */}
      <div className="contact-main">
        <div className="common-banner">
          <div className="container">
            <div className="common-head">
              <div className="line-head">
                <p>Get in touch with us</p>
              </div>
              <h1>Contact Us</h1>
            </div>
            {/* <p className="text-center">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod Ut enim ad minim veniam. Lorem ipsum dolor sit amet
            adipisicing.
          </p> */}
          </div>
        </div>

        <div className="container">
          <div className="get-in">
            <h5 className="sub-heading">get In touch</h5>
            <p>
              Intransit is here to simplify package deliveries by offering
              reliable and efficient package protection and tracking services
              for eCommerce. Our objective is to stay within easy reach for our
              customers so that they can get all their queries resolved in good
              time.
            </p>
            <p>
              We do have a detailed FAQ section for most of your queries.
              However, if you have very specific question to ask, please in our
              enquiry form below and we will get in touch with you ASAP.
            </p>
          </div>

          <div className="office-address">
            <div className="row">
              <div className="col-lg-6">
                <h5 className="sub-heading">We are here to help!</h5>
                <ul>
                  <li>
                    <AnimatedOnScroll
                      animationIn="zoomIn"
                      animationInDuration={1000}
                    >
                      <div className="address-icon">
                        <span>
                          <i class="fas fa-map-marker-alt"></i>
                        </span>
                      </div>
                    </AnimatedOnScroll>
                    <p>
                      <b>Address: </b>1234 Street Name, City Name, United States
                    </p>
                  </li>
                  <li>
                    <AnimatedOnScroll
                      animationIn="zoomIn"
                      animationInDuration={1000}
                    >
                      <div className="address-icon">
                        <span>
                          <i class="fas fa-phone-alt"></i>
                        </span>
                      </div>
                    </AnimatedOnScroll>
                    <p>
                      <b>Phone: </b>(123) 456-789
                    </p>
                  </li>
                  <li>
                    <AnimatedOnScroll
                      animationIn="zoomIn"
                      animationInDuration={1000}
                    >
                      <div className="address-icon">
                        <span>
                          <i class="fas fa-envelope"></i>
                        </span>
                      </div>
                    </AnimatedOnScroll>
                    <p>
                      <b>Email: </b>mail@example.com
                    </p>
                  </li>
                </ul>

                <div className="hours">
                  <h5 className="sub-heading">business hours</h5>
                  <ul>
                    <li>
                      <span>
                        <i class="far fa-clock"></i>
                      </span>
                      <p>Monday - Friday - 9am to 5pm</p>
                    </li>
                    <li>
                      <span>
                        <i class="far fa-clock"></i>
                      </span>
                      <p>Saturday - 9am to 2pm</p>
                    </li>
                    <li>
                      <span>
                        <i class="far fa-clock"></i>
                      </span>
                      <p>Sunday - Closed</p>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-6">
                <AnimatedOnScroll
                  animationIn="fadeInRight"
                  animationInDuration={2000}
                >
                  <div className="map-location-img">
                    <img src={MapBlur} />
                  </div>
                </AnimatedOnScroll>
              </div>
            </div>
          </div>

          <form className="message-form">
            <h5 className="sub-heading">Send Us A message</h5>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Your Name</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Phone Number</label>
                  <input type="number" className="form-control" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Your Email</label>
                  <input type="email" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Your Message</label>
                  <textarea
                    className="form-control"
                    rows="5"
                    placeholder="Your text here..."
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="text-center mt-3">
              <button className="yellow-btn">Send Message</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contact;
